// extracted by mini-css-extract-plugin
export default {"pillsList":"filterpill_pillsList__NCxFZ","iconWrapper":"filterpill_iconWrapper__E6XFB"};